import React from 'react';
import './index.scss';

export default ({ countryCode }) => {
  return (
    <div className={`country-flag iti-flag ${countryCode?.toLowerCase()}`} />
  );
};
